"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lab_1 = require("@material-ui/lab");
const react_redux_1 = require("react-redux");
const dropdownIcon_1 = __importDefault(require("../../../../svgIcons/dropdownIcon"));
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const filterItem_1 = __importDefault(require("./elements/filterItem"));
require("./filter.scss");
class Filter extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            multipleChecked: false
        };
    }
    render() {
        const { filterList, header, type, directoryType, handleExpanded, expanded } = this.props;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "filter-info-title" }, header),
            react_1.default.createElement(lab_1.TreeView, { expanded: expanded, onNodeToggle: (nodeId, nodeExpanded) => handleExpanded(nodeId, nodeExpanded), defaultCollapseIcon: react_1.default.createElement("span", { style: { transform: ' rotate(180deg)' } },
                    react_1.default.createElement(dropdownIcon_1.default, { fill: "#2EA0DC" })), defaultExpandIcon: react_1.default.createElement("span", null,
                    react_1.default.createElement(dropdownIcon_1.default, null)) }, filterList === null || filterList === void 0 ? void 0 : filterList.map((treeItemData, key) => react_1.default.createElement(filterItem_1.default, { directoryType: directoryType, type: type, key: key, data: treeItemData })))));
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts,
        areas: experts.areas
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExperts: (data) => dispatch(expertsSlice_1.getExperts(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Filter);
